((f) => {
    f(window.jQuery, window, document);
})(($, window, document) => {
        var $animationContainer;
        var $stages;
        var showAnimation;
        function set_edge_loader_callback(){
            AdobeEdge.bootstrapCallback(function (compId) {

                let $el = $('#' + compId);
                //stop animation
                let symbol = get_symbol_by_id(compId);

                symbol.stop();
                symbol.playReverse(symbol.getPosition());
                $el.data('loaded', true);
                $el.data('ready', true);
                //but we should check may be some stage is already visible
                //When we reload page in chrome it scrolls to the previous place but scroll event is not triggered - so checking
                generate_show_events();
                $(window).dequeue('animations');
            });
        }

        function load_edge_lib(done) {
            //is edge script Loaded?
            //we are not loading it at start because we don't need it for mobile
            if (!$animationContainer.data('edge-loaded')) {
                $.getScript("//animate.adobe.com/runtime/6.0.0/edge.6.0.0.min.js").done(() => {
                    $animationContainer.data('edge-loaded', true);
                    set_edge_loader_callback();
                    done();
                });
            }
            else {
                done();
            }
        }

        function dlf_load_animations() {

            //Show animation if container exists and is desktop
            showAnimation = ($animationContainer.length && ($(window).width() >= 980)) == true;

            if(showAnimation){
                load_edge_lib(function(){
                    var animProps = {
                        scaleToFit: "none",
                        centerStage: "none",
                        minW: "0px",
                        maxW: "undefined",
                        width: "980px",
                        height: "300px",
                        htmlRoot: $animationContainer.data('edge-root')
                    };
                    let domProps = {"dom": {}};
                    let stages = {'index_5': 'EDGE-289025725', 'index_4': 'EDGE-289025724'};

                    for(let fileName in stages){
                        let ident = stages[fileName];
                        if(!$('#'+ident).data('loaded')){
                            $(window).queue('animations', function(){
                                AdobeEdge.loadComposition(fileName, ident, animProps, domProps, domProps);
                            });
                        }
                    }
                    $(window).dequeue('animations');

                });
            }
        }

        function get_symbol_by_id(compId){
            let s = AdobeEdge.getComposition(compId + '');
            let result = null;
            if(s && s.getStage()) result = s.getStage().getSymbol('stage');

            return result;
        }

        function generate_show_events (){
            let $elem = $('.footer-area.indicator');
            let thisTop = 0;
            let topNavHeight = 30;

            if ($elem.offset() !== null) {
                thisTop = $elem.offset().top;
            }

            // Clear
            if (($(document).scrollTop() + $(window).height()) < thisTop || $(document).scrollTop() > (thisTop + $elem.parent().height())) {
                $stages.data('ready', true);
                return;
            }


            let docViewTop = $(window).scrollTop();
            let docViewBottom = docViewTop + $(window).height();

            $stages.each(function(i, elem){
                let elemTop = $(elem).offset().top;
                let elemBottom = elemTop + $(elem).height();
                if((elemBottom <= docViewBottom) && (elemTop >= docViewTop)){
                    $(elem).trigger('show-animation');
                    $(this).data('ready', false);
                }
            });
        }

        $(() => {
            $animationContainer = $('[data-edge-root]');
            $stages = $('.animation', $animationContainer);

            if($animationContainer.length)
                $(window).scroll(generate_show_events);

            $stages.on('show-animation', function(){
                let symbol = get_symbol_by_id(this.id);
                if(symbol && $(this).data('loaded') && $(this).data('ready') && !symbol.isPlaying()){
                    symbol.play();
                }
            });

            $(window).resize(dlf_load_animations);

            //initiate loading
            dlf_load_animations();
        });
    }
);

